 const SectionHeader = ({ icon, title, color }) => {
    return(
    <div className="d-flex align-items-center mb-0">
      <i className={`${icon} ${color} me-2`}></i>
      <p className="mb-0 fw-bold ml-3" style={{fontSize:"1.2rem"}}>{title}</p>
    </div>
    )
};

export default SectionHeader